module.exports = __webpack_public_path__ + "img/3exp.1a620671.jpg";